function PageFallback() {
  return <div className="page-fallback" aria-hidden="true" />;
}

export default PageFallback;
